import React, { useEffect, useState } from 'react';
import { getInstructorId,getAllThesisAssigned } from '../../services/thesisAssignedService';
import { getAllExaminerFeedbacks } from '../../services/feedbackService';
import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";



export const ThesisAssignedList=()=> {
    const [thesis, setThesis] = useState([]);
    
    const [instructorId, setInstructorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const examinerId = localStorage.getItem('examinerId');
    const location = useLocation();

 /*   const fetchThesis = async () => {
        try {
           
                if(examinerId!=-1){
                    const data = await getAllThesisAssigned(examinerId);
                    setThesis(data.data);
                }
           
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

   */ 

   

const fetchThesis = async () => {
    try {
        if (examinerId != -1) {
            const data = await getAllThesisAssigned(examinerId);
            const feedback = await getAllExaminerFeedbacks(examinerId);
            const feedbackList = feedback.data;
            const thesisList = data.data;
           // console.log(feedbackList);
           // console.log(examinerId)
            // Merge feedback with thesis
            const merged = thesisList.map(thesis => {
                const fb = feedbackList.find(
                    f => f.thesis_status_id === thesis.id //&&
                     //    f.examiner_id === examinerId
                );

                return {
                    ...thesis,
                    feedbackId: fb ? fb.id : null,
                 //   feedback: fb || null     // optional: full feedback
                };
            });
           // console.log(merged);
            setThesis(merged);
        }
    } catch (err) {
        setError(err);
    } finally {
        setLoading(false);
    }
};



    
    useEffect(() => {
        
        fetchThesis();
    }, []);
    const handleLinkClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
      };

    const columns = React.useMemo(
        () => [
            { field: 'thesis_title', headerName: 'Title', width: 200 },
            { field: 'student_name', headerName: 'Student Name', width: 150 },
            { field: 'enrollment_number', headerName: 'Enrollment Number', width: 150 },
            {
              field: 'combined_report', 
              headerName: 'Report Type', 
              width: 180, 
              renderCell: (params) => {
                const reportType = params.row?.report_type || '';
                const reportMonth = params.row?.report_month || '';
                if(reportType=='ProjectProposal')
                  return 'Project Proposal'
                return `${reportType}  ${reportMonth}`;
              },
            },
            { field: 'date', headerName: 'Viva Date', width: 150 },
            { field: 'startTime', headerName: 'Viva Start Time', width: 150 },
            { field: 'endTime', headerName: 'Viva End Time', width: 150 }
            // {
            //         field: 'rebuttal_report_link', headerName: 'Rebuttal Report Link', width: 250, renderCell: (params) => (
            //           <div style={{ display: 'flex', alignItems: 'center' }}>
            //             <Link
            //               href={params.value}
            //               onClick={(event) => handleLinkClick(params.value, event)}
            //               style={{
            //                 color: 'blue',
            //                 textDecoration: 'underline',
            //                 marginRight: '10px',
            //                 cursor: 'pointer',
            //               }}
            //             >
            //               {params.value}
            //             </Link>
            //           </div>
            //         ),
            //       }
            
        //     { field: 'folder_link', headerName: 'Folder Link', width: 250 ,renderCell: (params) => (
        //         <div style={{ display: 'flex', alignItems: 'center' }}>
        //         <Link
        //           href={params.value}
        //           onClick={(event) => handleLinkClick(params.value, event)}
        //           style={{
        //             color: 'blue',
        //             textDecoration: 'underline',
        //             marginRight: '10px',
        //             cursor: 'pointer',
        //           }}
        //         >
        //           {params.value}
        //         </Link>
        //       </div>
        //     ),
        // },
            
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Feedback (Form with Submitted Files and Previous Feedback)", width:425,
        renderCell:(params)=>{
            const { id ,student_id,reviewer_id1, reviewer_id2,is_feedback_by_reviewer1,is_feedback_by_reviewer2,examiner_id1, examiner_id2,is_feedback_by_examiner1,is_feedback_by_examiner2, feedbackId, share_to_student} = params.row;
          
           // console.log(share_to_student, id, feedbackId);
            return(
                <div className="cellAction">
                    {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_reviewer1) || 
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_reviewer2) || 
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_examiner1) || 
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_examiner2))
                     && 
                    <div className="editButton"><Link to={{pathname: `/feedbacks/newe/${id}`}} style={{textDecoration:"none" }}>Give Feedback</Link></div>}

                    {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) || 
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)|| 
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) || 
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2))
                     && 
                    <div className="editButton">Feedback Given</div>}

                    
                      {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) || 
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)|| 
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) || 
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2))
                     &&                   
                  <div className="viewButton"><Link 
  to={`/feedbacks/view-feedback/${feedbackId}`}
  state={{ from: location.pathname }}
>View</Link></div>}
                  
                            {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) || 
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)|| 
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) || 
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2)) && !share_to_student
                     &&           <div className="editButton"><Link to={`/feedbacks/edit-feedback/${feedbackId}`} state={{ from: location.pathname }} >Edit</Link></div>}
                                        
                {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) || 
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)|| 
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) || 
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2)) && share_to_student
                     && 
                    <div className="editButton">Feedback Shared with Student</div>}


                </div>
            );
        }
    }]

   {/* const viewColumn = [{ field: "view", headerName:"All Feedbacks", width:120,
      renderCell:(params)=>{
          const { id ,student_id,reviewer_id1, reviewer_id2,is_feedback_by_reviewer1,is_feedback_by_reviewer2,examiner_id1, examiner_id2,is_feedback_by_examiner1,is_feedback_by_examiner2} = params.row;
          return(
              <div className="cellAction">
                  <div className="viewButton"><Link to={{pathname: `view-feedbacks/${student_id}`}}>View</Link></div>
                  
              </div>
          );
      }
  }] */}

  
  
                      

    const handleFileChange = (event) => {
        setFile(null);
        const selectedFile = event.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          'application/vnd.ms-excel', // .xls
          'text/csv' // .csv
        ];

        if (selectedFile.size > maxFileSize) {
          toast.error('File size exceeds 10 MB limit');
          return;
        }

        if (!allowedTypes.includes(selectedFile.type)) {
          toast.error('Only Excel (.xlsx, .xls) and CSV (.csv) files are allowed');
          return;
        }
        setFile(selectedFile);
    };

    
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axiosInstance.post('/uploadThesis', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                showToastOnResponse: true
            });

           // console.log(response.data); 
            fetchThesis();// Handle success response
        } catch (error) {
            console.error('Error uploading file:', error); // Handle error response
        }
    };
    return (
        <div className="datatable" >
        <div className="datatableTitle">
            Assinged Thesis List
        </div>
      
      <DataGrid 
      rows={thesis}
      //columns={columns.concat(viewColumn).concat(actionColumn)}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

